"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppTitleBack = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--left/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.app-title-back {\n  display: flex;\n  width: 350px;\n  color: #000000;\n  margin: 0 auto;\n  padding: 0 1.5rem 1.5rem 0; }\n  .app-title-back svg {\n    flex-shrink: 0;\n    margin-right: 14px;\n    margin-top: 6px; }\n    .app-title-back svg:hover {\n      cursor: pointer; }\n  .app-title-back span {\n    font-family: 'LettrGoth12 BT W05 Regular', Arial;\n    font-size: 32px;\n    line-height: 40px; }\n  @media (max-width: 1055px) {\n    .app-title-back {\n      width: 288px; } }\n  @media (max-width: 671px) {\n    .app-title-back {\n      width: 202px; } }\n";
  const fileName = "AppTitleBack_AppTitleBack";
  const element = document.querySelector("style[data-sass-component='AppTitleBack_AppTitleBack']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AppTitleBack = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'app-title-back'
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: props.onClickBack
  }), /*#__PURE__*/_react.default.createElement("span", null, props.title));
};
exports.AppTitleBack = AppTitleBack;
AppTitleBack.propTypes = {
  onClickBack: _propTypes.default.func.isRequired,
  title: _propTypes.default.string.isRequired
};
var _default = exports.default = AppTitleBack;